import * as React from 'react';
import { IconEqual, IconRemove } from '../../components/icons';

interface Props {
	recommendationExceedsOfferLimit?: boolean;
	exceedsTwoMillions?: boolean;
	millionExpression?: number;
}
const CalculatorExplanation: React.StatelessComponent<Props> = props => {
	return (
		<div>
			<div className="row align-items-md-center">
				<div className="col-sm-12 col-md-4 border text-center p-3">
					<strong>Insurance Need</strong>
					<p className="mb-0">
						Includes your mortgage and other debts, inflation-adjusted education expenses, and income replacement needs.
					</p>
				</div>
				<div className="col-sm-12 col-md-1 text-center my-auto">
					<IconRemove />
				</div>
				<div className="col-sm-12 col-md-3 border text-center p-3">
					<strong>Assets</strong>
					<p className="mb-0">
						Your savings and existing life insurance.
					</p>
				</div>
				<div className="col-sm-12 col-md-1 text-center my-auto">
					<p className="mb-0"><IconEqual /></p>
				</div>
				<div className="col-sm-12 col-md-3 border text-center p-3">
					<strong>Coverage Amount</strong>
					<p className="mb-0">
						The amount of coverage you should buy, up to $1 million.
					</p>
				</div>
			</div>
			{(props.recommendationExceedsOfferLimit) && (!props.exceedsTwoMillions ?
				(<p className="mt-4 mb-0">
					Your recommended coverage amount based on your inputs is ${props.millionExpression} million.
					Mosaic Life can help you get most of the way there with a $1 million dollar policy.
				</p>) : (<p className="mt-4 mb-0">
					<strong>
					Your recommended coverage amount based on your inputs is ${props.millionExpression} millon.
					Mosaic Life only offers up to $1 million of coverage per individual.  </strong>
					We would love for you to apply for coverage
					with us, though we totally get it if you want to look elsewhere.
			</p>))}
		</div>
	);
};

export default CalculatorExplanation;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/advisory/CalculatorExplanation.tsx